import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendClick } from 'reaxl-analytics';
import { paymentDetailsVehicleCTAClick, paymentDetailsMakeChangesClick } from 'reaxl-analytics-handlers';
import { jsx } from 'react/jsx-runtime';
const ConnectedWalletPaymentDetailsModal = /*#__PURE__*/React.memo(_ref => {
  let {
    container,
    // For Syndicated Wallet
    paymentsDuck,
    vdpResultsDuck,
    ...rest
  } = _ref;
  const dispatch = useDispatch();
  const [WalletPaymentDetailsModal, setWalletPaymentDetailsModal] = useState(null);
  const {
    listingId: walletListingId,
    showPaymentDetailsModal,
    listingCategory
  } = useSelector(paymentsDuck.selectors.getMyWallet);
  const listing = useSelector(state => {
    if (vdpResultsDuck) {
      return vdpResultsDuck.selectors.getActiveInventory(state)?.[0];
    }
    return null;
  }) || {};
  useEffect(() => {
    if (showPaymentDetailsModal) {
      import(/* webpackChunkName: "WalletPaymentDetailsModal" */'./WalletPaymentDetailsModal.js').then(component => {
        setWalletPaymentDetailsModal(component.default);
      });
    }
  }, [showPaymentDetailsModal]);
  const handleModalClose = () => {
    dispatch(paymentsDuck.creators.updateMyWallet({
      showPaymentDetailsModal: false
    }));
  };
  const handleMakeChangeClick = event => {
    const inventoryId = listing?.id || walletListingId;
    dispatch(paymentsDuck.creators.updateMyWallet({
      displayModal: true,
      showPaymentDetailsModal: false
    }));
    sendClick(paymentDetailsMakeChangesClick, event, {
      inventoryId,
      par: 'pymt_dtl_modal',
      listingCategory,
      label: 'cta::make-changes'
    });
  };
  const handleViewVehicleDetailsClick = async event => {
    const inventoryId = listing?.id || walletListingId;
    await sendClick(paymentDetailsVehicleCTAClick, event, {
      inventoryId,
      listingCategory
    });
  };

  // TODO: figure out why walletListingId was used instead of listing.id
  return WalletPaymentDetailsModal && /*#__PURE__*/jsx(WalletPaymentDetailsModal, {
    container: container,
    listingId: listing?.id || walletListingId,
    paymentsDuck: paymentsDuck,
    onMakeChangeClick: handleMakeChangeClick,
    onHideModal: handleModalClose,
    onVehicleDetailsClick: handleViewVehicleDetailsClick,
    ...rest
  });
});
export { ConnectedWalletPaymentDetailsModal as default };
